<div *ngIf="isLoggedIn; else loginPrompt" class="grid md:grid-cols-3 grid-cols-1 gap-3">
  <ng-container *ngIf="user">
    <ng-container *ngIf="isMobileView; else desktopView">
      <app-information [user]="user" class="col-span-1"></app-information>
      <app-post [user]="user" class="col-span-1"></app-post>
    </ng-container>
    <ng-template #desktopView>
      <app-post [user]="user" class="md:col-span-2 col-span-1"></app-post>
      <app-information [user]="user" class="col-span-1"></app-information>
    </ng-template>
  </ng-container>
</div>

<ng-template #loginPrompt>
  <div class="container mx-auto max-w-screen-xl px-3 items-center justify-center bg-gray-100 mb-2">
    <div class="text-center p-6 bg-white shadow-md rounded-md">
      <h2 class="text-2xl font-semibold mb-4">Hello!</h2>
      <p class="text-lg mb-4">To view the complete profile, please log in.</p>
      <p class="text-md text-gray-600">
        If you don't have an account, you can sign up on our site.
      </p>
      <div class="mt-6 flex flex-col sm:flex-row gap-3">
        <button
          (click)="openLogin()"
          class="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-semibold rounded-lg shadow-md hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200 transform hover:-translate-y-0.5"
        >
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
            ></path>
          </svg>
          Log In
        </button>
        <button
          (click)="openRegister()"
          class="inline-flex items-center justify-center px-6 py-3 bg-white text-gray-700 font-semibold rounded-lg border-2 border-gray-300 shadow-md hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition-all duration-200"
        >
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
            ></path>
          </svg>
          Sign Up
        </button>
      </div>
    </div>
  </div>
</ng-template>
